import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { AvailableAction } from "@/utils/available-actions";

export interface ChartingAvailableActionsResponse {
  availableActions: ChartingAvailableActionsResponse_Action[];
}

export enum ChartingAvailableAction {
  READ_EPISODE_OF_CARE = "read-episode-of-care",
  READ_OBJECTIVE = "read-objective",
  READ_SCRATCHPAD = "read-scratchpad",
  READ_SUBJECTIVE = "read-subjective",

  WRITE_EPISODE_OF_CARE = "write-episode-of-care",
  WRITE_OBJECTIVE = "write-objective",
  WRITE_SCRATCHPAD = "write-scratchpad",
  WRITE_SUBJECTIVE = "write-subjective",
  WRITE_CARE_PLAN = "write-care-plan",
  GENERATE_AV_CALL_SUBJECTIVE = "generate-av-call-subjective",
}

export enum ChartingAvailableActionsUnavailabilityReason {
  INVALID_ENCOUNTER_TYPE = "INVALID_ENCOUNTER_TYPE",
  INVALID_ENCOUNTER_STATUS = "INVALID_ENCOUNTER_STATUS",
}
export interface ChartingAvailableActionsResponse_Action {
  action: ChartingAvailableAction;
  unavailableReason?: ChartingAvailableActionsUnavailabilityReason;
}

export const useChartingAvailableActions = ({
  patientId,
  motherEncounterId,
}: {
  patientId: string;
  motherEncounterId: string;
}) => {
  return useApi<ChartingAvailableActionsResponse, AvailableAction[]>({
    queryOptions: {
      queryFn: async () => {
        const response =
          await axiosInstance.get<ChartingAvailableActionsResponse>(
            `/charting/encounter-charting/${motherEncounterId}/available-actions`,
          );
        return response.data;
      },
      enabled: Boolean(motherEncounterId),
      queryKey: QueryKeys.Patient.Chart.AVAILABLE_ACTIONS({
        patientId,
        motherEncounterId,
      }),
      select: (data: ChartingAvailableActionsResponse) => {
        return data.availableActions.map((action) => ({
          action: action.action,
          unavailableReasons: action.unavailableReason
            ? [action.unavailableReason]
            : [],
        }));
      },
    },
  });
};
